import Vue from 'vue';
import SvgIcon from '../../store-customization-v2/components/SvgIcon.vue';

new Vue({
    el: '#descricaoAtividadeCaracteristicas',
    components: { SvgIcon },
});
